import { getTimezones } from '@shipstation/client-common/api/reference-data.api';
import { useQuery } from '@tanstack/react-query';

import { LocalStorageService } from '../services/local-storage-service';

import type { Timezone } from '@shipstation/client-common/types/reference-data';

// Longest fixed staleTime that works: setTimeout caps at 2^31-1 ms (~24.8 days), and React Query schedules a timer for it.
const STALE_TIME_24_DAYS = 24 * 24 * 60 * 60 * 1000;
const TIMEZONES_STORAGE_KEY = 'reference-data-timezones';

export const useTimezonesQuery = (isOpen: boolean) => {
  return useQuery({
    queryKey: ['timezones'],
    queryFn: async () => {
      const timezones = await getTimezones();
      LocalStorageService.setItem(TIMEZONES_STORAGE_KEY, timezones);
      return timezones;
    },
    initialData: (LocalStorageService.getItem(TIMEZONES_STORAGE_KEY) as Timezone[] | undefined) ?? undefined,
    staleTime: STALE_TIME_24_DAYS,
    enabled: isOpen,
    retry: 1,
  });
};
